import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class Minus2Day extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = -2;

  public getName(): string {
    return Translator.trans("payment-offset-minus-2-day");
  }

}

export { Minus2Day }
